module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("They have a slightly transparency and are queued to not confuse the user.")]), _vm._v(" "), _c('p', [_c('small', [_c('b', [_vm._v("Note:")]), _vm._v(" They queue with "), _c('router-link', {
    attrs: {
      "to": "/documentation/snackbar"
    }
  }, [_vm._v("Snackbars")]), _vm._v(" as well.")], 1)])]), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "From inside Vue instance",
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "From outside Vue instance"
    }
  }, [_c('p', [_vm._v("You can use it on Vuex or VueRouter using this syntax:")]), _vm._v(" "), _c('CodeView', {
    attrs: {
      "lang": "javascript",
      "code": _vm._f("pre")(_vm.outsideVueInstance),
      "expanded": ""
    }
  })], 1), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  }), _vm._v(" "), _c('VariablesView', {
    attrs: {
      "data": _vm.variables
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-214ab73d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/toast/Toast.vue
// module id = 1567
// module chunks = 39